<kr-logo />

<nav class="kr-sidebar__nav">
  <kr-sidebar-nav-item
    *ngxPermissionsOnly="'treasurerDashboard'"
    data-testid="home"
    link="/"
    iconName="home"
    i18nKey="shell.sidebar.nav.dashboard"
    exactRoute />

  <!--  <kr-sidebar-nav-item-->
  <!--    *ngxPermissionsOnly="'limiterLimits'"-->
  <!--    link="/companies"-->
  <!--    iconName="companies"-->
  <!--    i18nKey="shell.sidebar.nav.companies" />-->

  <kr-sidebar-nav-item
    *ngxPermissionsOnly="'treasurerWallets'"
    data-testid="wallets"
    link="/wallets"
    iconName="wallet"
    i18nKey="shell.sidebar.nav.wallets" />

  <kr-sidebar-nav-item
    *ngxPermissionsOnly="['limiterLimits', 'treasurerWallets']"
    data-testid="api"
    link="/api"
    iconName="wallet"
    i18nKey="shell.sidebar.nav.api" />

  <kr-sidebar-nav-item
    *ngxPermissionsOnly="'limiterLimits'"
    data-testid="limits"
    link="/limits"
    iconName="badge"
    i18nKey="shell.sidebar.nav.limits" />

  <kr-sidebar-nav-item
    link="/risk-score"
    data-testid="risk_score"
    iconName="discount"
    i18nKey="shell.sidebar.nav.riskScore" />

  @if (dictionaries.isCryptoBanco()) {
    <kr-sidebar-nav-item
      iconName="help"
      data-testid="help"
      (click)="openSupportChat()"
      i18nKey="shell.sidebar.nav.support" />
  }

  <!--  <kr-sidebar-nav-item-->
  <!--    link="/exchange"-->
  <!--    iconName="exchange"-->
  <!--    i18nKey="shell.sidebar.nav.exchange" />-->

  <kr-sidebar-nav-item
    link="/account"
    data-testid="account"
    iconName="account"
    i18nKey="shell.sidebar.nav.myAccount" />
</nav>
